import {createFileRoute} from "@tanstack/react-router";
import {PipelinePage} from "~/modules/dataPipeline/page";
import {Route as Parent} from "../route";
export const Route = createFileRoute("/_withAuthenticationStatus/_authenticated/_withProfileStatus/_profileCompleted/a/_adminScaffold/data-pipeline/")({
    component: Page,
});
function Page() {
    return (
        <PipelinePage
            context={Parent.useLoaderData()}
            filters={Parent.useSearch()}
            view="overview"
        />
    );
}
